import { render, staticRenderFns } from "./lianxiwm.vue?vue&type=template&id=843f689c&"
import script from "./lianxiwm.vue?vue&type=script&lang=js&"
export * from "./lianxiwm.vue?vue&type=script&lang=js&"
import style0 from "./lianxiwm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports